import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import api, { apiError, notifyChange, todayISO } from "../../lib/api";
import { toast } from "sonner";
import PatientSelect from "../PatientSelect";

export default function PaymentModal({ open, onClose, prefill }) {
  const [patient, setPatient] = useState(null);
  const [date, setDate] = useState(todayISO());
  const [amount, setAmount] = useState(prefill?.amount || "");
  const [causale, setCausale] = useState(prefill?.causale || "");
  const [method, setMethod] = useState("contanti");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!patient) { toast.error("Seleziona un paziente"); return; }
    if (!amount || Number(amount) <= 0) { toast.error("Inserisci un importo valido"); return; }
    setSaving(true);
    try {
      await api.post("/payments", {
        patient_id: patient.id, date, amount: Number(amount), causale,
        method, notes, appointment_id: prefill?.appointment_id || null,
      });
      toast.success("Pagamento registrato");
      notifyChange();
      onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="payment-modal">
        <DialogHeader><DialogTitle className="font-heading text-xl">Registra pagamento</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Paziente *</Label><PatientSelect value={patient} onChange={setPatient} data-testid="payment-patient" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Data</Label><Input data-testid="payment-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-xl" /></div>
            <div><Label>Importo (€) *</Label><Input data-testid="payment-amount" type="number" min="0" step="0.5" value={amount} onChange={(e) => setAmount(e.target.value)} className="rounded-xl" /></div>
          </div>
          <div><Label>Causale</Label><Input data-testid="payment-causale" value={causale} onChange={(e) => setCausale(e.target.value)} placeholder="Es. Seduta fisioterapia" className="rounded-xl" /></div>
          <div>
            <Label>Metodo</Label>
            <Select value={method} onValueChange={setMethod}>
              <SelectTrigger data-testid="payment-method" className="rounded-xl"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="contanti">Contanti</SelectItem>
                <SelectItem value="carta/POS">Carta/POS</SelectItem>
                <SelectItem value="bonifico">Bonifico</SelectItem>
                <SelectItem value="altro">Altro</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label>Note</Label><Input data-testid="payment-notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="rounded-xl" /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" data-testid="payment-cancel-btn" onClick={onClose} className="rounded-full">Annulla</Button>
          <Button data-testid="payment-save-btn" onClick={save} disabled={saving} className="rounded-full">{saving ? "Salvataggio..." : "Registra"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
